// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper_LJEOc","inner":"Header_inner_1xrj6","logo":"Header_logo_3fuEw","search":"Header_search_2fHd-"};